import NotificationModal from '@anm/components/modals/NotificationModal';
import { NotificationElement } from '@anm/hooks/useNotifications';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import useCreateBrandFileNotification from '../../my-projects/VideoFolders/hooks/useAddToBrandNotification';

import { hostedVideoSelectors } from '../../../store/modules/hostedVideo';
import { landingsSelectors } from '../../../store/modules/landings';
import { videoFolderSelectors } from '../../../store/modules/videoFolder';
import useDuplicateProjectNotifications from '../../my-projects/VideoFolders/hooks/useDuplicateProjectNotifications';

import useEmbedNotifications from './hooks/useEmbedNotifications';
import useLandingsNotifications from './hooks/useLandingsNotifications';
import useNotificationPosition from './hooks/useNotificationPosition';
import useUploadPosterNotifications from './hooks/useUploadPosterNotifications';
import useVideoConfigsNotifications from './hooks/useVideoConfigsNotifications';
import useVideoDataNotifications from './hooks/useVideoDataNotifications';
import { brandSelectors } from '../../../store/modules/brands';

const Notifications: FC = () => {
  const { uploadPoster } = useSelector(hostedVideoSelectors.selectHostedVideo);
  const updateProjectMeta = useSelector(videoFolderSelectors.selectUpdateProjectMeta);
  const updateConfigs = useSelector(hostedVideoSelectors.selectSaveConfigsStatus);
  const saveLandingEntity = useSelector(landingsSelectors.selectSaveLanding);
  const savePasswordEntity = useSelector(hostedVideoSelectors.selectSavePasswordStatus);
  const saveEmbedStatusEntity = useSelector(hostedVideoSelectors.selectSaveEmbed);
  const createBrandFileState = useSelector(brandSelectors.selectCreateBrandFileState);
  const duplicateProject = useSelector(videoFolderSelectors.selectDuplicateProject);

  const uploadPosterNotifications = useUploadPosterNotifications(uploadPoster);
  const videoDataNotifications = useVideoDataNotifications(updateProjectMeta);
  const videoConfigsNotifications = useVideoConfigsNotifications(updateConfigs);
  const landingsNotifications = useLandingsNotifications(saveLandingEntity);
  const embedNotifications = useEmbedNotifications(saveEmbedStatusEntity);
  const passwordNotifications = useEmbedNotifications(savePasswordEntity);
  const duplicateNotifications = useDuplicateProjectNotifications(duplicateProject);
  const createBrandFileNotifications = useCreateBrandFileNotification(createBrandFileState);

  const mappedDuplicateNotifications = duplicateNotifications.map(n => ({
    ...n,
    action: 'duplicate'
  }));

  const notifications = [
    ...uploadPosterNotifications,
    ...videoConfigsNotifications,
    ...videoDataNotifications,
    ...landingsNotifications,
    ...embedNotifications,
    ...passwordNotifications,
    ...mappedDuplicateNotifications,
    ...createBrandFileNotifications
  ];

  const [notificationPosition] = useNotificationPosition();

  return (
    <>
      {notifications.map(({ id, type, action, deleteNotification, ...rest }: NotificationElement) => {
        const timeout = type === 'success' ? 2000 : 4000;
        const variant = action === 'duplicate' ? 'aside' : 'custom';

        return (
          <NotificationModal
            key={id}
            position={notificationPosition}
            onModalClose={() => deleteNotification(id)}
            {...{ type, timeout, variant, ...rest }}
          />
        );
      })}
    </>
  );
};

export default Notifications;
